import { render } from "./App.vue?vue&type=template&id=bb8b90ca&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=bb8b90ca&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__